namespace GeniuzPOS.InitialData {
    export namespace PsPanelGroupButtonService {
        export const baseUrl = 'InitialData/PsPanelGroupButton';

        export declare function Create(request: Serenity.SaveRequest<PsPanelGroupButtonRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsPanelGroupButtonRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsPanelGroupButtonRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsPanelGroupButtonRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetNextNumber(request: GetNextNumberRequest, onSuccess?: (response: GetNextNumberResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "InitialData/PsPanelGroupButton/Create",
            Update = "InitialData/PsPanelGroupButton/Update",
            Delete = "InitialData/PsPanelGroupButton/Delete",
            Retrieve = "InitialData/PsPanelGroupButton/Retrieve",
            List = "InitialData/PsPanelGroupButton/List",
            GetNextNumber = "InitialData/PsPanelGroupButton/GetNextNumber"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetNextNumber'
        ].forEach(x => {
            (<any>PsPanelGroupButtonService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
